interface PageLayoutProps {
  children: React.ReactNode
  wide?: boolean
  header?: React.ReactNode
}

export function PageLayout({ children, wide = false, header }: PageLayoutProps) {
  const maxW = wide ? 'max-w-7xl' : 'max-w-6xl'

  if (header) {
    return (
      <div className={`${maxW} mx-auto w-full min-w-0 flex flex-col min-h-full`}>
        {/*
         * Sticky header: -mx-6 px-6 extends the background to the full width of
         * <main> (which has px-6), ensuring the sticky area covers scrolling content
         * edge-to-edge. top-14 matches the AppShell Topbar height (h-14 = 56px).
         */}
        <div className="sticky top-0 z-10 pt-6 bg-[var(--color-bg-app)] flex flex-col gap-4">
          {header}
          <div className="h-px bg-[var(--color-border)]" />
        </div>
        <div className={`flex flex-col gap-4 sm:gap-6 pt-5 pb-6 [&>*]:min-w-0`}>{children}</div>
      </div>
    )
  }

  return (
    <div className={`flex flex-col gap-4 sm:gap-6 mx-auto w-full min-w-0 [&>*]:min-w-0 ${maxW}`}>
      {children}
    </div>
  )
}
